import { useState } from 'react';
import { Button, EmptyState, ErrorState, Group, Icon, SearchField } from '@store/ui';
import { api } from '../api';
import { fillScreen, ListSkeleton, ProductRow, useAsync } from './shared';

// --- Catalog ----------------------------------------------------------------

export function CatalogScreen({
  categoryId,
  onNavigate,
}: {
  categoryId: string | null;
  onNavigate: (route: string) => void;
}) {
  const [search, setSearch] = useState('');
  const [applied, setApplied] = useState('');

  const products = useAsync(
    () =>
      api.products({
        ...(categoryId ? { categoryId } : {}),
        ...(applied ? { search: applied } : {}),
      }),
    [categoryId, applied],
  );

  const categories = useAsync(() => api.categories(), []);
  const active = categories.data?.categories.find((category) => category.id === categoryId);

  return (
    <div className="container stack">
      <header>
        <h1 className="title">{active ? active.title : 'Каталог'}</h1>
        {/* A filter you cannot see is a filter you cannot undo. */}
        {active ? (
          <button
            type="button"
            className="button button--ghost"
            style={{ marginTop: 'var(--space-1)', marginLeft: 'calc(var(--space-2) * -1)' }}
            onClick={() => onNavigate('/catalog')}
          >
            <Icon name="close" size={16} />
            Показать всё
          </button>
        ) : null}
      </header>

      <SearchField
        value={search}
        onChange={setSearch}
        onSubmit={() => setApplied(search.trim())}
        placeholder="Поиск товара"
        label="Поиск товара"
      />

      {products.loading ? (
        <ListSkeleton rows={4} />
      ) : products.error ? (
        <div style={fillScreen}>
          <ErrorState
            title="Не удалось загрузить"
            text={products.error}
            onRetry={products.reload}
          />
        </div>
      ) : products.data?.products.length ? (
        <Group>
          {products.data.products.map((product) => (
            <ProductRow
              key={product.id}
              product={product}
              onOpen={(shortId) => onNavigate(`/product/${shortId}`)}
            />
          ))}
        </Group>
      ) : (
        <div style={fillScreen}>
          <EmptyState
            icon="search"
            title="Ничего не нашли"
            text={applied ? `По запросу «${applied}» результатов нет.` : 'В этой категории пусто.'}
            {...(applied
              ? {
                  action: (
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setSearch('');
                        setApplied('');
                      }}
                    >
                      Сбросить поиск
                    </Button>
                  ),
                }
              : {})}
          />
        </div>
      )}
    </div>
  );
}
